import { useState, useContext, useEffect, useRef } from "react";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  CardHeader,
  Col,
  Row,
  Button,
  ButtonGroup,
} from "reactstrap";
import AppContext from "../../contexts/appContext";
import { createChart, updateChart } from "../../modules/callCharts";

import "../testing/media.css";
import { HOST_SERVICE } from "../../modules/bm";
import { CHART_COLORS } from "../../modules/helper";
import { DateTime } from "luxon";

function TestsChart({ dispatch }) {
  const appState = useContext(AppContext);
  const chartTests = useRef();
  const [series, setSeries] = useState([]);
  const [props, setProps] = useState([]); // To store the list of properties from services
  const [selectedProps, setSelectedProps] = useState("score");
  const [selectedSeries, setSelectedSeries] = useState([]);

  const CHART_MAIN_COLOR = {
    score: CHART_COLORS.purple,
    executionTime: CHART_COLORS.orange,
    count: CHART_COLORS.pink,
  };

  const keepProps = (array) => {
    const firstObject = array.length > 0 ? array[0] : null;
    if (firstObject) {
      const props = Object.keys(firstObject);
      const filteredProps = props.filter((prop) =>
        ["score", "executionTime", "count"].includes(prop)
      );
      return filteredProps;
    }
    return [];
  };

  const PROPSLABEL = {
    score: "Score (in %)",
    executionTime: "Execution Time (in ms)",
    count: "Total execution counter",
  };

  const getLabels = (prop) => {
    switch (prop) {
      case "status":
        return ["", "success", "warning", "error", "unknown"];
      case "coturnService":
        return ["", "inactive", "active", "unknown", ""];
      default:
        return null;
    }
  };

  const changeSeries = (selectedProps, series) => {
    if (series.length > 0) {
      const graphSeries = series.map((elt) => ({
        x: elt._id,
        y: elt[selectedProps],
      }));

      setSelectedSeries(graphSeries);
    }
  };

  const getButtonsList = (items) => {
    return items.map((item, index) => (
      <Button
        key={index}
        color="info"
        id="0"
        size="sm"
        tag="label"
        className={classNames("btn-simple", {
          active: selectedProps === item,
        })}
        onClick={() => {
          setSelectedProps(item);
        }}
      >
        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
          {item}
        </span>
        <span className="d-block d-sm-none">
          <i className="tim-icons icon-single-02" />
        </span>
      </Button>
    ));
  };

  useEffect(() => {
    if (selectedSeries.length > 0) {
      updateChart(selectedSeries, null, chartTests, 2, 60000, true, null);
    }
  }, [selectedSeries]);

  useEffect(() => {
    changeSeries(selectedProps, series);
  }, [series]);

  useEffect(() => {
    createChart(document.querySelector("#chartTests"), chartTests, "MONTHLY", {
      prop: PROPSLABEL[selectedProps],
      colorProp: CHART_MAIN_COLOR[selectedProps],
      maxY: 60000,
      isLine: true,
      labels: getLabels(selectedProps),
      unit: "day",
    });
    changeSeries(selectedProps, series);
  }, [selectedProps]);

  useEffect(() => {
    if (appState.series[HOST_SERVICE.TESTS]) {
      const tests = appState.series[HOST_SERVICE.TESTS];
      setSeries(tests);
      setProps(
        keepProps(appState.series[HOST_SERVICE.TESTS], HOST_SERVICE.TESTS)
      );
    }
  }, [appState.series]);

  return (
    <Card className="card">
      <CardHeader>
        <Row>
          <Col className="text-left" sm="6">
            <h5 className="card-category">Host System Metrics Trend</h5>
            <CardTitle tag="h3">Tests</CardTitle>
          </Col>
          <Col className="text-left" sm="6">
            <ButtonGroup
              className="btn-group-toggle float-right"
              data-toggle="buttons"
            >
              {getButtonsList(props)}
            </ButtonGroup>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md="12">
            <div className="chart-container">
              <canvas id="chartTests"></canvas>
            </div>
          </Col>
        </Row>
      </CardBody>
      <CardFooter></CardFooter>
    </Card>
  );
}

export default TestsChart;
